/* DLT Performance Fase 3B — Runtime Core.
   Mantem apenas componentes globais criticos e carrega modulos opcionais por presenca no DOM. */
import { timeline } from "@dlt/vendor";
import { EffectCarousel } from "@dlt/theme";
var AnnouncementBar = class extends EffectCarousel {
  _transitionTo(fromSlide, toSlide) {
    timeline([
      [fromSlide, { transform: ["translateY(0)", "translateY(-5px)"], opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }],
      [toSlide, { transform: ["translateY(5px)", "translateY(0)"], opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 }]
    ]);
  }
};
if (!window.customElements.get("announcement-bar")) {
  window.customElements.define("announcement-bar", AnnouncementBar);
}

import { animate, timeline as timeline3, stagger, Delegate as Delegate2 } from "@dlt/vendor";
import { AnimatedDetails, EffectCarousel as EffectCarousel2, Drawer, throttle } from "@dlt/theme";
var reduceMenuAnimation = JSON.parse("false");
var StoreHeader = class extends HTMLElement {
  connectedCallback() {
    this._abortController?.abort();
    this._abortController = new AbortController();

    const signal = this._abortController.signal;
    this._trackHideOnScroll = this.hasAttribute("hide-on-scroll");
    this._lastScrollTop = window.scrollY;
    this._accumulatedScroll = 0;
    this._isVisible = true;
    this._hasSwitchedToSticky = false;
    this._hasTransparentHeader = false;

    this._direction = 0;
    this._frame = 0;
    this.dataset.dltScrollState = "visible";
    this._scrollListener = () => {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        if (this._trackHideOnScroll) this._onScroll();
        if (this.hasAttribute("sticky") && this._hasTransparentHeader) this._checkTransparency();
      });
    };
    this._overlayObserver?.disconnect();
    this._overlayObserver = new MutationObserver(this._scrollListener);
    this._overlayObserver.observe(document.body, {
      subtree: true, attributes: true, attributeFilter: ["open", "aria-expanded", "aria-hidden", "class", "checked"]
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Tab") {
        this._keyboardNavigation = true;
        this.show();
      }
    }, { signal });
    ["pointerdown", "touchstart", "wheel"].forEach((name) => {
      document.addEventListener(name, () => { this._keyboardNavigation = false; }, { passive: true, signal });
    });
    document.addEventListener("focusin", () => {
      if (this.contains(document.activeElement)) this.show();
    }, { signal });
    document.addEventListener("change", this._scrollListener, { signal });
    document.addEventListener("toggle", this._scrollListener, { capture: true, signal });

    if (
      this._trackHideOnScroll ||
      this.hasAttribute("sticky")
    ) {
      window.addEventListener("scroll", this._scrollListener, {
        passive: true,
        signal
      });
    }

    this.addEventListener(
      "toggle",
      this._checkTransparency.bind(this),
      { capture: true, signal }
    );
    this.addEventListener(
      "mouseenter",
      this._checkTransparency.bind(this),
      { signal }
    );
    this.addEventListener(
      "mouseleave",
      this._checkTransparency.bind(this),
      { signal }
    );

    window.addEventListener(
      "pageshow",
      (event) => {
        if (event.persisted) {
          this.classList.remove("is-filled");
          this._setupTransparentHeader();
        }
      },
      { signal }
    );

    if (Shopify.designMode && this.hasAttribute("sticky")) {
      document.addEventListener(
        "shopify:section:load",
        this._setupTransparentHeader.bind(this),
        { signal }
      );
      document.addEventListener(
        "shopify:section:unload",
        this._setupTransparentHeader.bind(this),
        { signal }
      );
      document.addEventListener(
        "shopify:section:reorder",
        this._setupTransparentHeader.bind(this),
        { signal }
      );
    }

    this._setupTransparentHeader();
  }
  disconnectedCallback() {
    this._abortController?.abort();
    this._overlayObserver?.disconnect();
    cancelAnimationFrame(this._frame);
  }
  _setScrollVisibility(visible) {
    if (this._isVisible === visible) return;
    this._isVisible = visible;
    this.dataset.dltScrollState = visible ? "visible" : "hidden";
    this.dispatchEvent(new CustomEvent("dlt:header:visibility", { bubbles: true, detail: { visible } }));
  }
  hide() { this._setScrollVisibility(false); }
  show() {
    this._accumulatedScroll = 0;
    this._setScrollVisibility(true);
  }
  _onScroll() {
    const y = Math.max(0, window.scrollY);
    const delta = y - this._lastScrollTop;
    const locked = this._keyboardNavigation || this.contains(document.activeElement) || this.querySelector("[open], [aria-expanded='true']") ||
      document.querySelector('dialog[open], [aria-modal="true"][open], .drawer[open], cart-drawer[open], .dlt-b2b-menu-open') ||
      this.closest("height-observer")?.querySelector("[data-dlt-b2b-mobile-state]:checked");
    if (locked || y <= this.offsetHeight) {
      this.show();
      this._direction = 0;
    } else if (Math.abs(delta) >= 1) {
      const direction = Math.sign(delta);
      if (direction !== this._direction) this._accumulatedScroll = 0;
      this._direction = direction;
      this._accumulatedScroll += Math.abs(delta);
      if (this._accumulatedScroll >= 12) {
        if (direction > 0) this.hide(); else this.show();
      }
    }
    this._lastScrollTop = y;
  }
  _checkTransparency() {
    const hasOpenDisclosure =
      this.querySelector("[open]") !== null;
    let hasFallbackScrollDetection = false;

    if (
      CSS.supports("selector(:has(> *))") &&
      this.hasAttribute("sticky") &&
      !this.hasAttribute("hide-on-scroll") &&
      this.hasAttribute("allow-transparency")
    ) {
      const offsetBeforeChanging = 500;

      if (hasOpenDisclosure) {
        this.classList.add("is-filled");
      } else if (
        window.scrollY >= offsetBeforeChanging &&
        !this._hasSwitchedToSticky
      ) {
        this._hasSwitchedToSticky = true;
        this.classList.add("is-filled");
        animate(
          this,
          {
            transform: [
              "translateY(-100%)",
              "translateY(0)"
            ]
          },
          { duration: 0.15, easing: "ease" }
        );
      } else if (window.scrollY < offsetBeforeChanging) {
        if (this._hasSwitchedToSticky) {
          this._hasSwitchedToSticky = false;
          animate(
            this,
            {
              transform: [
                "translateY(0)",
                "translateY(-100%)"
              ]
            },
            { duration: 0.15, easing: "ease" }
          ).finished.then(() => {
            this.style.transform = null;
            this.classList.remove("is-filled");
          });
        } else if (this.getAnimations().length === 0) {
          this.classList.remove("is-filled");
        }
      }
    } else {
      hasFallbackScrollDetection = window.scrollY > 20;
      this.classList.toggle(
        "is-filled",
        !this.hasAttribute("allow-transparency") ||
          hasOpenDisclosure ||
          hasFallbackScrollDetection
      );
    }
  }
  _setupTransparentHeader() {
    this._hasTransparentHeader = Boolean(
      document.querySelector(
        ".shopify-section:first-child [allow-transparent-header]"
      )
    );

    if (this._hasTransparentHeader) {
      this.setAttribute("allow-transparency", "");
      this._checkTransparency();
    } else {
      this.removeAttribute("allow-transparency");
    }
  }
};
var DropdownDisclosure = class _DropdownDisclosure extends AnimatedDetails {
  constructor() {
    super();
    this._detectClickOutsideListener = this._detectClickOutside.bind(this);
    this._detectEscKeyboardListener = this._detectEscKeyboard.bind(this);
    this._detectFocusOutListener = this._detectFocusOut.bind(this);
    this._detectHoverListener = this._detectHover.bind(this);
    this._hoverTimer = null;
    this.addEventListener("mouseover", this._detectHoverListener.bind(this));
    this.addEventListener("mouseout", this._detectHoverListener.bind(this));
  }
  get trigger() {
    return !window.matchMedia("screen and (pointer: fine)").matches ? "click" : this.getAttribute("trigger");
  }
  get mouseOverDelayTolerance() {
    return 250;
  }
  _onSummaryClicked(event) {
    if (this.trigger === "hover") {
      event.preventDefault();
      if (event.currentTarget.hasAttribute("data-url")) {
        window.location.href = event.currentTarget.getAttribute("data-url");
      }
    } else {
      super._onSummaryClicked(event);
    }
  }
  async _transition(value) {
    if (value) {
      this.setAttribute("open", "");
      document.addEventListener("click", this._detectClickOutsideListener);
      document.addEventListener("keydown", this._detectEscKeyboardListener);
      document.addEventListener("focusout", this._detectFocusOutListener);
      const openSiblings = Array.from(this.closest("ul").querySelectorAll("[open]")).filter((item) => item !== this);
      openSiblings.forEach((sibling) => sibling.open = false);
      await this._transitionIn(openSiblings.length > 0);
    } else {
      document.removeEventListener("click", this._detectClickOutsideListener);
      document.removeEventListener("keydown", this._detectEscKeyboardListener);
      document.removeEventListener("focusout", this._detectFocusOutListener);
      await this._transitionOut();
      this.removeAttribute("open");
    }
  }
  _transitionIn(hasOpenSiblings = false) {
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }]];
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      timelineSequence.push([this.contentElement.querySelectorAll(":scope > ul > li"), { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { delay: stagger(0.025), at: "-0.1", duration: 0.2 }]);
    }
    return timeline3(timelineSequence, { delay: hasOpenSiblings > 0 ? 0.1 : 0 }).finished;
  }
  _transitionOut() {
    return timeline3([[this.contentElement, { opacity: 0 }, { duration: 0.2 }]]).finished;
  }
  _detectClickOutside(event) {
    if (this.trigger !== "click") {
      return;
    }
    if (!this.contains(event.target) && !(event.target.closest("details") instanceof _DropdownDisclosure)) {
      this.open = false;
    }
  }
  _detectHover(event) {
    if (this.trigger !== "hover") {
      return;
    }
    if (event.type === "mouseover") {
      this.open = true;
      clearTimeout(this._hoverTimer);
    } else {
      this._hoverTimer = setTimeout(() => this.open = false, this.mouseOverDelayTolerance);
    }
  }
  _detectEscKeyboard(event) {
    if (event.code === "Escape") {
      const targetMenu = event.target.closest("details[open]");
      if (targetMenu) {
        targetMenu.open = false;
      }
    }
  }
  _detectFocusOut(event) {
    if (event.relatedTarget && !this.contains(event.relatedTarget)) {
      this.open = false;
    }
  }
};
var MegaMenuDisclosure = class extends DropdownDisclosure {
  constructor() {
    super();
    this.addEventListener("pointerover", this._preloadImages.bind(this));
  }
  get mouseOverDelayTolerance() {
    return 500;
  }
  _transitionIn(hasOpenSiblings) {
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }], "mega-menu"], contentDelay = hasOpenSiblings ? 0.1 : 0;
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      this.contentElement.querySelectorAll(".mega-menu__promo").forEach((promo) => {
        timelineSequence.push([promo, { opacity: [0, 1] }, { duration: 0.25, delay: contentDelay, at: "mega-menu" }], "mega-menu-promo");
      });
      this.contentElement.querySelectorAll(".mega-menu__nav > li").forEach((column) => {
        timelineSequence.push([column.querySelectorAll(":scope > :first-child, :scope li"), { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", delay: stagger(0.025, { start: contentDelay }), at: "mega-menu", duration: 0.2 }]);
      });
    }
    return timeline3(timelineSequence).finished;
  }
  _preloadImages() {
    Array.from(this.querySelectorAll('img[loading="lazy"]')).forEach((image) => image.setAttribute("loading", "eager"));
  }
};
var MegaMenuPromoCarousel = class extends EffectCarousel2 {
  connectedCallback() {
    super.connectedCallback();
    if (this.nextElementSibling) {
      this.addEventListener("carousel:select", (event) => this._updateControlsColor(event.detail.slide));
    }
    this._updateControlsColor(this.items[this.selectedIndex]);
  }
  _updateControlsColor(slide) {
    const controls = this.nextElementSibling;

    if (!slide || !controls) {
      return;
    }

    const extractFrom = slide.classList.contains("content-over-media") ? slide : slide.firstElementChild;

    if (!extractFrom) {
      return;
    }

    controls.style.setProperty("--text-color", extractFrom.style.getPropertyValue("--text-color"));
  }
};
var NavigationDrawer = class extends Drawer {
  constructor() {
    super();
    const delegate = new Delegate2(this);
    delegate.on("click", "button[data-panel]", this._onPanelButtonClick.bind(this));
    this._isTransitioning = false;
    this.addEventListener("dialog:after-hide", () => {
      this.reinitializeDrawer();
    });
  }
  get openFrom() {
    return window.matchMedia("(max-width: 699px)").matches ? this.getAttribute("mobile-opening") : super.openFrom;
  }
  switchToPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let panelToHideTransform, panelToShowTransform, panelToHide = linkListIndex !== null ? panels[parseInt(panelIndex) - 1] : panels[parseInt(panelIndex) + 1], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper"), timelineSequence = [];
    if (document.dir === "rtl") {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(100%)"] : ["translateX(0%)", "translateX(-100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(-100%)", "translateX(0%)"] : ["translateX(100%)", "translateX(0%)"];
    } else {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(-100%)"] : ["translateX(0%)", "translateX(100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(100%)", "translateX(0%)"] : ["translateX(-100%)", "translateX(0%)"];
    }
    timelineSequence.push(
      [panelToHide, { transform: panelToHideTransform, opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.3, opacity: { at: "+0.3" }, transform: { at: "+0.3" } }],
      "panelHidden",
      [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"], transform: panelToShowTransform }, { at: "<", transform: { duration: 0.3 } }]
    );
    if (linkListIndex !== null) {
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    timeline3(timelineSequence);
  }
  showPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let timelineSequence = [], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper");
    if (!panelToShow.hasAttribute("open") && !this._isTransitioning) {
      this._isTransitioning = true;
      timelineSequence.push(
        [this, { width: [this.offsetWidth + "px", (this.offsetWidth - parseInt(window.getComputedStyle(this).getPropertyValue("padding"))) * 2 + "px"] }, { duration: 0.2 }],
        [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" }]
      );
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
      timelineSequence.push([linkLists[this.previousLinkIndex], { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }]);
    }
    timeline3(timelineSequence).finished.then(() => {
      if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
        linkLists[this.previousLinkIndex].removeAttribute("style");
      }
      if (panelToShow.hasAttribute("open") && this.previousLinkIndex !== linkListIndex) {
        timeline3([this.switchLinkList(linkLists, linkListIndex)]);
      }
      this.previousLinkIndex = linkListIndex;
      panelToShow.setAttribute("open", "");
      this._isTransitioning = false;
    });
  }
  switchLinkList(linkLists, linkListIndex) {
    Array.from(linkLists).forEach((item) => {
      item.setAttribute("hidden", "");
    });
    linkLists[linkListIndex].removeAttribute("hidden");

    if (window.matchMedia("(max-width: 749px), (pointer: coarse)").matches) {
      return [linkLists[linkListIndex], { opacity: [0, 1], visibility: ["hidden", "visible"] }, { easing: "ease-out", duration: 0.14, at: "-0.08" }];
    }

    return [linkLists[linkListIndex].querySelectorAll("li"), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", duration: 0.2, at: "-0.15", delay: stagger(0.025, { start: 0.1 }) }];
  }
  reinitializeDrawer() {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.style.removeProperty("width");
      this.setExpanded();
    } else {
      const firstPanel = this.querySelector(".panel:first-child");
      firstPanel.style.opacity = "1";
      firstPanel.style.visibility = "visible";
      firstPanel.style.transform = "translateX(0%)";
    }
    Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach((item) => {
      if (this.hasAttribute("mega-menu")) {
        item.removeAttribute("open");
      }
      item.style.opacity = "0";
      item.style.visibility = "hidden";
      Array.from(item.querySelectorAll(".panel__wrapper")).forEach((list) => list.setAttribute("hidden", ""));
    });
  }
  setExpanded(target) {
    Array.from(this.querySelectorAll("button[data-panel]")).forEach((item) => {
      item.setAttribute("aria-expanded", "false");
    });
    if (target) {
      target.setAttribute("aria-expanded", "true");
    }
  }
  _onPanelButtonClick(event, target) {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.setExpanded(target);
      this.showPanel(...target.getAttribute("data-panel").split("-"));
    } else {
      this.switchToPanel(...target.getAttribute("data-panel").split("-"));
    }
  }
};
if (!window.customElements.get("store-header")) {
  window.customElements.define("store-header", StoreHeader);
}
if (!window.customElements.get("dropdown-disclosure")) {
  window.customElements.define("dropdown-disclosure", DropdownDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-disclosure")) {
  window.customElements.define("mega-menu-disclosure", MegaMenuDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-promo-carousel")) {
  window.customElements.define("mega-menu-promo-carousel", MegaMenuPromoCarousel);
}
if (!window.customElements.get("navigation-drawer")) {
  window.customElements.define("navigation-drawer", NavigationDrawer);
}

import { Drawer as Drawer2 } from "@dlt/theme";
var NewsletterPopup = class extends Drawer2 {
  connectedCallback() {
    super.connectedCallback();

    /*
     * O FocusTrap fica desligado somente nesta newsletter para evitar o
     * fechamento acidental ao focar o campo. Mantemos Escape explicitamente.
     */
    this.addEventListener(
      "keydown",
      (event) => {
        if ((event.key === "Escape" || event.key === "Esc") && this.open) {
          event.preventDefault();
          this.hide();
        }
      },
      { signal: this._abortController.signal }
    );

    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }
  get initialFocus() {
    return false;
  }
  /*
   * DLT Newsletter hardening v4.5
   *
   * Este popup usa o Drawer apenas para ciclo open/close + scroll lock.
   * O FocusTrap do Drawer cruza Shadow DOM + conteudo slotted e, em alguns
   * navegadores/integracoes, pode classificar o clique no input como externo.
   * Isso dispara a desativacao do dialogo e fecha o popup no primeiro clique.
   *
   * Para a newsletter, o foco continua nativo e totalmente editavel. O modal
   * segue fechando pelos botoes X / continuar e por Escape (DialogElement).
   */
  get shouldTrapFocus() {
    return false;
  }
  _allowOutsideClick() {
    return true;
  }
  get shouldAppendToBody() {
    return false;
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppearAutomatically() {
    return !(localStorage.getItem("theme:popup-filled") === "true" || this.hasAttribute("only-once") && localStorage.getItem("theme:popup-appeared") === "true");
  }
  _setInitialPosition() {
    this.style.top = null;
    this.style.bottom = "0px";
    this.style.left = document.dir === "ltr" ? null : "0px";
    this.style.right = document.dir === "rtl" ? "auto" : "0px";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:popup-appeared", "true");
    }
  }
};
if (!window.customElements.get("newsletter-popup")) {
  window.customElements.define("newsletter-popup", NewsletterPopup);
}


/* DLT Fase 3B — component-aware module loader.
   Import maps em theme.liquid fornecem URLs versionadas dos chunks opcionais. */
const __dltOptionalSectionModules = [
  {
    selector: 'account-login',
    specifier: '@dlt/sections-account'
  },
  {
    selector: 'product-recommendations, recently-viewed-products',
    specifier: '@dlt/sections-product'
  },
  {
    selector: 'split-cursor',
    specifier: '@dlt/sections-before-after'
  },
  {
    selector: 'collection-list, feature-chart, image-banner, image-link-blocks, images-with-text-scrolling, refresh-text, media-grid, media-with-text, multiple-images-with-text, multiple-images-with-text-image-list, multiple-images-with-text-content-list, press-carousel, revealed-image, shop-the-look-dots, x-slideshow, slideshow-carousel',
    specifier: '@dlt/sections-content'
  }
];

const __dltLoadedSectionModules = new Map();

function __dltImportSectionModule(specifier) {
  if (!__dltLoadedSectionModules.has(specifier)) {
    __dltLoadedSectionModules.set(
      specifier,
      import(specifier).catch((error) => {
        __dltLoadedSectionModules.delete(specifier);
        console.error(`[DLT] Falha ao carregar modulo opcional ${specifier}`, error);
        throw error;
      })
    );
  }

  return __dltLoadedSectionModules.get(specifier);
}

function __dltLoadModulesForRoot(root = document) {
  for (const module of __dltOptionalSectionModules) {
    const matchesRoot = root instanceof Element && root.matches?.(module.selector);
    const containsMatch = root.querySelector?.(module.selector);

    if (matchesRoot || containsMatch) {
      __dltImportSectionModule(module.specifier);
    }
  }
}

__dltLoadModulesForRoot(document);

document.addEventListener('shopify:section:load', (event) => {
  __dltLoadModulesForRoot(event.target);
});